<template>
    <img src="../../assets/taichi.png" class="portrait_play"/>
</template>

<script>
    import { reactive, toRefs, computed } from 'vue'

    export default {
        name: 'PortraitPlay',
        props: {},
        setup: (props, context) => {
            const state = reactive({
                props,
            })

            return {
                ...toRefs(state),
            }
        }
    }
</script>

<style scoped lang="scss">
    .portrait_play {
        animation-name: rotate;
        animation-duration: 30s;
        animation-timing-function:linear;
        /*animation-direction: alternate;*/
        animation-iteration-count: infinite;
    }

    @keyframes rotate {
        0% {
            transform: rotateZ(0deg);
            -ms-transform: rotateZ(0deg);
            -moz-transform: rotateZ(0deg);
            -webkit-transform: rotateZ(0deg);
            -o-transform: rotateZ(0deg);
        }

        100% {
            transform: rotateZ(360deg);
            -ms-transform: rotateZ(360deg);
            -moz-transform: rotateZ(360deg);
            -webkit-transform: rotateZ(360deg);
            -o-transform: rotateZ(360deg);
        }
    }
</style>